import { render, staticRenderFns } from "./CafDashboard.vue?vue&type=template&id=f5ef3a08&"
import script from "./CafDashboard.vue?vue&type=script&lang=js&"
export * from "./CafDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CafDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CafDashboard.vue"
export default component.exports